import { mapState } from 'vuex';
import { getObjProperty } from "@utilities/mrVueUtils";

export default {
  computed: {
    ...mapState('customer', ['cdata']),
  },
  methods: {
    mix_bestMatchObj(productType) {
      if (!getObjProperty(this.cdata, 'bestMatches') && !productType) {
        return;
      }
      return this.cdata.bestMatches.find(a => a.productType == productType);
    },

    mix_bestMatchUrl(productType, options) {
      if (!getObjProperty(options, 'url') && productType) {
        return;
      }
      let match = this.mix_bestMatchObj(productType);
      if (match) {
        return '/product/' + match.urlKey;
      } else {
        return options.url;
      }
    },
    mix_bestMatchName(productType) {
      let match = this.mix_bestMatchObj(productType);
      if (match) {
        return match.name;
      }
      return;
    }
  }
};